/**
 * Copyright © Redbox Digital Ltd, Inc. All rights reserved.
 * See COPYING.txt for license details.
 */

define('Magento_Customer/js/show-password',[
    'jquery',
    'mage/translate',
    'mage/mage',
    'domReady!'
], function ($, $t) {
    'use strict';

    return function () {
        $('.show-hide-pw').on('click', function() {
            var pwField = $(this).siblings('input.input-text');
            if (pwField.get(0).type === 'password') {
                pwField.prop('type', 'text');
                $(this).text($t('Hide'));
            } else {
                pwField.prop('type', 'password');
                $(this).text($t('Show'));
            }
        });
    };
});

